import React, { useEffect, useRef, useState } from "react";
import "./AddQuoteModal.css";
import { getServicesAPI } from "../../../../utils/APIs/servicesApis";
import { getCustomersAPI } from "../../../../utils/APIs/customerApis";
import AddCustomerModal from "../../../Customer/AddCustomerModal/AddCustomerModal";
import { toast } from "react-toastify";
import { createQuoteAPI } from "../../../../utils/APIs/quoteApis";
import Loader from "../../../../Loader/Loader";
import LocationPickerMap from "./LocationPikerMap/LocationPikerMap";
const AddQuoteModal = ({ isOpen, onClose, fetchQuotes }) => {
    const [userSearch, setUserSearch] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingPreferences, setEditingPreferences] = useState(false);
    const [requirements, setRequirements] = useState([]);
    const LIMIT = 10;
    // const indianStates = State.getStatesOfCountry("IN");
    // const [statesList, setStatesList] = useState([]);
    // const [citiesList, setCitiesList] = useState([]);
    const [isAddressOpen, setIsAddressOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [totalUsers, setTotalUsers] = useState(0);

    const totalPages = Math.ceil(totalUsers / LIMIT);
    const [formData, setFormData] = useState({
        eventType: "",
        startDate: "",
        endDate: "",
        location: "",
        // requirements: "",
        currentBudget: "",
        flatOrHouseNo: "",
        streetName: "",
        city: "",
        postalCode: "",
        state: "",
        userId: "",
    });



    const [services, setServices] = useState([]);
    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [loadingAddQuote, setLoadingAddQuote] = useState(false);
    const dropdownRef = useRef(null);


    const getTomorrowDate = () => {
        const today = new Date();
        today.setDate(today.getDate() + 1);

        return today.toISOString().split("T")[0]; // format YYYY-MM-DD
    };

    const minDate = getTomorrowDate();

    const handleLocationSelect = (data) => {

        console.log("MAP DATA:", data);
        // const isoState = convertStateNameToISO(data.state);

        setFormData((prev) => ({
            ...prev,
            location: data.location || "",
            address: data.location || "",
            lat: data?.lat || "",
            lng: data?.lng || "",
            streetName: data.streetName || "",
            city: data.city || "",
            state: data.state || "",
            postalCode: data.postalCode || "",
        }));
    };

    const handleRequirementChange = (value) => {
        setRequirements([value]);
    };

    // useEffect(() => {
    //     if (isOpen) {
    //         const states = State.getStatesOfCountry("IN");
    //         setStatesList(states);
    //     }
    // }, [isOpen]);

    // useEffect(() => {
    //     if (formData.state) {
    //         const cities = City.getCitiesOfState("IN", formData.state);
    //         setCitiesList(cities);
    //     } else {
    //         setCitiesList([]);
    //     }
    // }, [formData.state]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    useEffect(() => {
        if (!isOpen) return;

        fetchServices();
        fetchUsers(page);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, page]);

    const fetchServices = async () => {
        try {
            const res = await getServicesAPI();
            setServices(res?.data?.data || []);
        } catch (error) {
            console.error("Service fetch failed", error);
        }
    };

    const fetchUsers = async (pageNo = page) => {
        try {
            setLoadingUsers(true);

            const res = await getCustomersAPI(pageNo, LIMIT);

            setUsers(res?.data?.data || []);
            setTotalUsers(res?.data?.meta?.total || 0);
            setPage(res?.data?.meta?.page || pageNo);

        } catch (error) {
            console.error("User fetch failed", error);
        } finally {
            setLoadingUsers(false);
        }
    };

    if (!isOpen) return null;

    const filteredUsers = users.filter((user) =>
        user.username?.toLowerCase().includes(userSearch.toLowerCase()) ||
        user.mobileNumber?.includes(userSearch)
    );


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "state") {
            setFormData({
                ...formData,
                state: value,
                city: "" // reset city
            });
            return;
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const resetForm = () => {
        setFormData({
            eventType: "",
            startDate: "",
            endDate: "",
            location: "",
            address: "",
            lat: "",
            lng: "",
            currentBudget: "",
            flatOrHouseNo: "",
            streetName: "",
            city: "",
            postalCode: "",
            state: "",
            userId: "",
        });

        setRequirements([]);
        setEditingPreferences(false);
        setUserSearch("");
        setIsDropdownOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();



        if (!formData.eventType) {
            toast.error("Please select an Event Type");
            return;
        }
        if (!formData.startDate || !formData.endDate) {
            toast.error("Please select a Start date and End date");
            return;
        }
        if (requirements.length === 0) {
            toast.error("Please select requirements");
            return;
        }
        if (!formData.location) {
            toast.error("Please select a location");
            return;
        }
        if (!formData.currentBudget) {
            toast.error("Please select a Budget");
            return;
        }
        if (!formData.flatOrHouseNo) {
            toast.error("Please select a flat/HouseNo");
            return;
        }
        if (!formData.city) {
            toast.error("Please select a city");
            return;
        }
        if (!formData.postalCode) {
            toast.error("Please select a postal code");
            return;
        }
        if (!formData.state) {
            toast.error("Please select a state");
            return;
        }
        if (!formData.userId) {
            toast.error("Please select a customer");
            return;
        }

        if (!formData.location) {
            toast.error("Please select a location");
            return;
        }




        if (formData.startDate > formData.endDate) {
            toast.error("End date must be after start date");
            return;
        }

        try {
            const selectedService = services.find(
                (s) => s._id === formData.eventType
            );

            const selectedUser = users.find(
                (u) => u._id === formData.userId
            );

            const payload = {
                service_id: formData.eventType,
                clientId: formData.userId,
                eventType: selectedService?.serviceName || "",
                startDate: formData.startDate,
                endDate: formData.endDate,
                eventDate: formData.startDate, // you can change if needed
                location: formData.location,
                lat: formData.lat,
                lng: formData.lng,
                address: formData.address,
                // eventDuration: 1, // you can calculate dynamically if needed
                // photographyRequirements: requirements,
                requirements: requirements,
                // photographyRequirements: [requirements].join(", "),
                clientName: selectedUser?.username,
                phoneNumber: selectedUser?.mobileNumber,
                email: selectedUser?.email,
                budget: formData.currentBudget,
                quoteStatus: "pending",
                editingPreferences: editingPreferences,
                flatOrHouseNo: formData?.flatOrHouseNo,
                streetName: formData?.streetName,
                city: formData?.city,
                postalCode: formData?.postalCode,
                state: formData?.state,
                isQuoteFinal: true
            };
            setLoadingAddQuote(true)
            const response = await createQuoteAPI(payload);

            if (response?.data?.success) {
                toast.success(response?.data?.message || "Quote Created Successfully!");
                fetchQuotes()
                resetForm();
                onClose();
            } else {
                toast.error(response?.data?.message || "Failed to create quote");
            }
        } catch (error) {
            setLoadingAddQuote(false)
            console.error("Create Quote Error:", error);
            toast.error("Something went wrong");
        }
        finally {
            setLoadingAddQuote(false)
        }
    };

    if (loadingAddQuote) {
        return <Loader />
    }
    return (
        <div className="quote-modal-overlay">
            <div className="quote-modal-container">

                <div className="quote-modal-header">
                    <h3>Add Quote</h3>
                </div>

                <div className="quote-modal-body">
                    <form id="quoteForm" onSubmit={handleSubmit} className="quote-form">

                        <div className="form-group">
                            <label>Event Type *</label>
                            <select
                                name="eventType"
                                value={formData.eventType}
                                onChange={handleChange}
                            // required
                            >
                                <option value="">Select Event Type</option>
                                {services.map((service) => (
                                    <option key={service._id} value={service._id}>
                                        {service.serviceName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Budget *</label>
                            <input
                                type="number"
                                name="currentBudget"
                                value={formData.currentBudget}
                                onChange={handleChange}
                            />
                        </div>


                        <div className="form-group">
                            <label>Start Date *</label>
                            <input
                                type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                                min={minDate}
                            />
                        </div>

                        <div className="form-group">
                            <label>End Date *</label>
                            <input
                                type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                                min={formData.startDate || minDate}
                            />
                        </div>


                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Requirements *</label>
                            <div className="budget-row">
                                {/* <label className="budget-label">
                                    Coverage Required <span className="text-danger">*</span>
                                </label> */}

                                <div className="budget-options">
                                    {["Photography", "Videography", "Complete Coverage (Photo + Video)"].map((item) => (
                                        <label key={item} className="budget-option-item">
                                            <input
                                                type="radio"
                                                name="requirements"
                                                checked={requirements.includes(item)}
                                                onChange={() => handleRequirementChange(item)}
                                            />
                                            {item}
                                        </label>
                                    ))}
                                </div>
                            </div>


                        </div>

                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Editing Preference *</label>
                            <div className="budget-row">
                                <div className="budget-options" style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                                    <label className="budget-option-item" style={{ marginBottom: 0 }}>
                                        <input
                                            type="radio"
                                            name="editingPreferences"
                                            checked={editingPreferences === true}
                                            onChange={() => setEditingPreferences(true)}
                                        />
                                        Yes
                                    </label>
                                    <label className="budget-option-item" style={{ marginBottom: 0 }}>
                                        <input
                                            type="radio"
                                            name="editingPreferences"
                                            checked={editingPreferences === false}
                                            onChange={() => setEditingPreferences(false)}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* 

                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Select Location from Map</label>
                            <LocationPickerMap onSelect={handleLocationSelect} />
                        </div>


                        <div className="form-group">
                            <label>Event Location *</label>
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="w-100"

                            />
                        </div>




                        <div className="form-group">
                            <label>Flat / House No. *</label>
                            <input
                                type="text"
                                name="flatOrHouseNo"
                                value={formData.flatOrHouseNo}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Street Name </label>
                            <input
                                type="text"
                                name="streetName"
                                value={formData.streetName}
                                onChange={handleChange}
                                readOnly
                            />
                        </div>



                        <div className="form-group">
                            <label>State *</label>
                            <select
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                disabled
                            >
                                <option value="">Select State</option>
                                {statesList.map((state) => (
                                    <option key={state.isoCode} value={state.isoCode}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>City *</label>
                            <select
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                disabled
                            >
                                <option value="">Select City</option>
                                {citiesList.map((city) => (
                                    <option key={city.name} value={city.name}>
                                        {city.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Postal Code *</label>
                            <input value={formData.postalCode} readOnly className="readonly" />
                        </div> */}



                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <div
                                className={`accordion-header ${isAddressOpen ? "open" : ""}`}
                                onClick={() => setIsAddressOpen(!isAddressOpen)}
                            >
                                <span>Event Address & Location</span>
                                <span className="arrow">{isAddressOpen ? "▲" : "▼"}</span>
                            </div>

                            <div className={`accordion-body ${isAddressOpen ? "show" : ""}`}>
                                {isAddressOpen && (
                                    <>
                                        <div className="inner-grid">
                                            <div className="form-group" style={{ gridColumn: "span 2" }}>
                                                <label>Select Location from Map</label>
                                                <LocationPickerMap onSelect={handleLocationSelect} />
                                            </div>

                                            <div className="form-group">
                                                <label>Event Location *</label>
                                                <input
                                                    type="text"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Flat / House No. *</label>
                                                <input
                                                    type="text"
                                                    name="flatOrHouseNo"
                                                    value={formData.flatOrHouseNo}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Street Name</label>
                                                <input
                                                    type="text"
                                                    name="streetName"
                                                    value={formData.streetName}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>State *</label>
                                                <input value={formData.state} readOnly />
                                            </div>

                                            <div className="form-group">
                                                <label>City *</label>
                                                <input value={formData.city} readOnly />
                                            </div>

                                            <div className="form-group">
                                                <label>Postal Code *</label>
                                                <input value={formData.postalCode} readOnly />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Customer *</label>
                            <div className="user-dropdown" ref={dropdownRef}>
                                <div className="dropdown-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search Customer by name or mobile..."
                                        value={userSearch}
                                        onChange={(e) => {
                                            setUserSearch(e.target.value);
                                            setIsDropdownOpen(true);
                                        }}
                                        onFocus={() => setIsDropdownOpen(true)}
                                    />
                                    <span className="dropdown-arrow">▼</span>
                                </div>

                                {isDropdownOpen && (
                                    <div className="assign-photographer-dropdown-list">
                                        {loadingUsers ? (
                                            <div className="assign-photographer-dropdown-status">Loading customers...</div>
                                        ) : filteredUsers.length === 0 ? (
                                            <div className="dropdown-empty">
                                                <p>No customer found</p>
                                                <button
                                                    type="button"
                                                    className="btn-primary"
                                                    onClick={() => {
                                                        setIsDropdownOpen(false);
                                                        setIsModalOpen(true);
                                                    }}
                                                >
                                                    + Add New Customer
                                                </button>
                                            </div>
                                        ) : (
                                            filteredUsers.map((user) => (
                                                <div
                                                    key={user._id}
                                                    className={`assign-photographer-dropdown-item ${formData.userId === user._id ? "selected" : ""
                                                        }`}
                                                    onClick={() => {
                                                        setFormData({ ...formData, userId: user._id });
                                                        setUserSearch(
                                                            user.username || user.mobileNumber || user.email
                                                        );
                                                        setIsDropdownOpen(false);
                                                    }}
                                                >
                                                    <div className="user-name">{user.username}</div>
                                                    <div className="user-mobile">{user.mobileNumber}</div>
                                                    {user.email && (
                                                        <div className="user-email">{user.email}</div>
                                                    )}
                                                    <hr className="assign-photographer-text" />
                                                </div>
                                            ))
                                        )}

                                           {totalPages > 1 && filteredUsers.length > 0 && (
                                    <div className="pagination">
                                        <button
                                            type="button"
                                            className="pagination-btn"
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            Prev
                                        </button>

                                        {[...Array(totalPages)].map((_, i) => (
                                            <button
                                                type="button"
                                                key={i}
                                                className={`pagination-btn ${page === i + 1 ? "active" : ""}`}
                                                onClick={() => setPage(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        ))}

                                        <button
                                            type="button"
                                            className="pagination-btn"
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                                    </div>

                                            

                                )}

                             
                            </div>


                        </div>

                    </form>


                    <AddCustomerModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onSuccess={fetchUsers}
                    />
                </div>

                <div className="quote-modal-footer">
                    <button className="btn-secondary" type="button"
                        onClick={() => {
                            resetForm();
                            onClose();
                        }}>
                        Cancel
                    </button>
                    <button className="btn-primary" type="submit" form="quoteForm">
                        Save Quote
                    </button>
                </div>

            </div>
        </div>
    );
};

export default AddQuoteModal;